import { SearchParameters } from "@coveo/headless";
import { PageType } from "components/coveo-headless/types/coveo-headless-types";

const createFacetsUrlString = (facetsObj: Record<string, string[]>) => {
	let facetsUrlString = "";
	Object.keys(facetsObj).forEach((facet) => {
		let facetValue: string[] = [];
		facetValue = facetsObj[facet];
		facetsUrlString += `&f:@${facet}=[${[...facetValue]}]`;
	});
	return facetsUrlString;
};
/**
 * Create new urlHash when user makes UI changes via filters
 */
const serializeUrl = (urlParams: SearchParameters, filtersSortCriteria: string, page: string) => {
	let newUrlString = "";
	if (page === PageType.Search) {
		/**
		 * Search page possible urls:
		 * search#q=etfs&sort=relevancy (redirect from any other page BUT the search page
		 * 		OR typing in the url or searching for new term in searchbox on search page)
		 * search#sort=relevancy (enter key is pressed with no value in search box on search page)
		 * search#sort=relevancy&f:@tagtopic=[Investment Principles] (click from content card in search page)
		 * search#q=etfs&sort=relevancy&f:@tagapprovedcountries=[Canada] (facet filtering)
		 * search#q=etfs&sort=relevancy&f:@tagapprovedcountries=[Canada]&f:@tagformat=[Brochure] (facet filtering)
		 */
		if (urlParams.q) {
			newUrlString += `#q=${urlParams.q}`;
			newUrlString += `&sort=${filtersSortCriteria}`;
		} else {
			newUrlString += `#sort=${filtersSortCriteria}`;
		}
		if (urlParams.f) {
			newUrlString += createFacetsUrlString(urlParams.f);
		}
	} else if (page === PageType.Insights) {
		if (urlParams.tab) {
			const tab = urlParams.tab;
			newUrlString = `#t=cat${tab}`;
		}

		if (filtersSortCriteria) {
			newUrlString += `&sort=${filtersSortCriteria}`;
		}

		if (urlParams.f) {
			newUrlString += createFacetsUrlString(urlParams.f);
		}
	} else if (page === PageType.MyDimensional) {
		newUrlString += `#sort=${filtersSortCriteria}`;

		if (urlParams.f) {
			newUrlString += createFacetsUrlString(urlParams.f);
		}
	}
	return newUrlString;
};

export default serializeUrl;
